import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Table from "../ui/Table";
import Label from "../ui/Label";
import Spin from "../ui/Spin";
import { drawPrice, runEvent, timeAgo } from "../utils/Utils";
import OtherConditions from "./OtherConditions";
import Checkbox from "../ui/Checkbox";
import Cookies from "js-cookie";
import { PlusIcon } from "../utils/Icons";
import GroupPicker from "./GroupPicker";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";

export default function InventoryPubstock(props) {

    const {
        controller = "",
        is_order = false,
        pubstock = [],
        width = 611,
        loading = false,
        state = "",
        setState = () => { },
        other_conditions = [],
        conditionSelected = {},
        callback = () => { },
        onSelectSupplier = () => { },
        can_toggle = true
    } = props;

    const [fetching, setFetching] = useState(false);
    const [data, setData] = useState([...pubstock]);
    const [pinned, setPinned] = useState(false);
    const fItems = data.filter(i => i.priority === "F");
    const maxFDisplayOrder = Math.max(...fItems.map(i => i.display_order), -Infinity);
    const filtered = data.filter(i => i.priority === "F" || i.display_order < maxFDisplayOrder);
    const displayed = (state === "min" && filtered.length > 0) ? filtered : data;

    // Handle pinned
    let pinnedData = null;
    if (pinned) {
        const supplierMatches = data.filter(item => item.supplier === pinned);
        pinnedData = (supplierMatches.length > 0) ? supplierMatches : [{ supplier: pinned, onhand: "No stock" }];
    }

    // Final output
    const filteredData = pinned ? pinnedData : displayed;


    useEffect(() => {
        if (Array.isArray(pubstock)) {
            setData([...pubstock]);
        }

        let _route = ROUTES.INVENTORY.ORDER;
        switch (props.view) {
            case "inventory":
            case "inventory_full":
                _route = ROUTES.INVENTORY.INVENTORY
                break;
            case "history":
                _route = ROUTES.INVENTORY.HISTORY
                break;

        }
       



        const cleanup = listen(controller, _route, [{ key: KBD.L, action: () => fetchLive([...pubstock]) }], false, [], [KBD.F2], [], null);
        return cleanup;
    }, [props.pubstock, state])


    const togglePin = (_obj) => {
        if (pinned) {
            setPinned(false);
        } else {
            setPinned(_obj?.supplier);
        }
    }

    const colorSupp = (_text, _status, _new = false) => {


        if (_status === "F") {
            return (<strong style={{ "fontWeight": "700" }} className={(_new) ? "text-green" : "text"}>{_text}</strong>)
        } else
            if (_status === "Y") {
                return (<strong className={(_new) ? "text-green" : "text-light"}>{_text}</strong>)
            } else {
                return (<span className={(_new) ? "text-green" : "label"}>{_text}</span>)
            }
    }

    const colorReturn = (e) => {
        if (e === "N") {
            return (<span className="text-red">{e}</span>)
        }
        if (e === "C") {
            return (<span className="text-yellow">{e}</span>)
        }
        return e;
    }

    const today = dayjs().format("MMMDD");

    const colorAsOf = (_date) => {
        if (!_date) return;

        return (timeAgo(_date * 1000, true))
    }

    const prices = data.filter(item => {
        if (item.priority !== "P" && item.exchange_rate === 1 && item.profit_margin >= 40) {
            return true;
        } else {
            return false;
        }
    }).map(item => item.sell_price);
    const minSalesPrice = prices.length ? Math.min(...prices) : 0;

    const getP2 = (_cost = 0) => {
        if (minSalesPrice <= 0) return "-";
        const margin = ((minSalesPrice - _cost) / minSalesPrice) * 100;
        return (margin >= 0 && margin < 100) ? Math.round(margin) : "**";
    };

    const drawMore = () => {

        if (!can_toggle) {
            return (<>Supp</>)
        }
        const favs = data.filter(item => item.priority === "F");
        const maxFDisplayOrder = favs.length ? Math.max(...favs.map(i => i.display_order)) : -Infinity;
        const moreItems = data.filter(item => item.priority !== "F" && item.display_order >= maxFDisplayOrder);
        const allItems = data.filter(item => item.supplier !== pinned);

        if (pinned) {
            return (
                <small>
                    <a onClick={() => { setPinned(false); setState("full") }}>
                        + {allItems.length} more
                    </a>
                </small>
            )

        }

        if (filtered.length === 0) {
            return <>SupWH</>;
        }

        if (state === "min") {
            if (!moreItems.length) {
                return <>SupWH</>;
            }
            return (
                <small>
                    <a onClick={() => setState("full")}>
                        + {moreItems.length} more
                    </a>
                </small>
            );
        } else {
            return (
                <small>
                    <a onClick={() => setState("min")}>Favs only</a>
                </small>
            );
        }
    };

    const columns = [
        {
            key: "supplier", width: 60, shrink: true, align: "left", grow: true, title: <>{drawMore()}</>, render: (e, f) => {
                return <span className="pubstock-supp" onClick={() => { onSelectSupplier(f); }} >{colorSupp(e, f?.priority)}</span>;
            }
        },
        {
            key: "order_separator", width: 17, shrink: true, align: "center", grow: true, title: <>Gp</>, render: (e, f) => {
                return <span className="pubstock-supp" ><GroupPicker onSelect={(e) => onSelectSupplier(f, e)} offset={[-8, -10]} active={true}><a><PlusIcon /></a></GroupPicker></span>;
            }
        },

        {
            key: "onhand", width: 44, grow: true, title: <>O/H</>, render: (e, f) => {

                if (e === "No stock") {
                    return (<span style={{ "position": "absolute", bottom: "2px", left: "85px", "color": "var(--text-red)" }}><small>N/A</small></span>)
                }

                if (f?.new_onhand) {
                    return colorSupp(f?.new_onhand, f?.priority, true)
                } else {
                    return colorSupp(e, f?.priority)
                }

                return (<span className={(f?.priority === "P") ? "label" : "text-green"}>{e}</span>)
            }
        },
        {
            key: "onorder", width: 44, grow: true, title: <>O/O</>, render: (e, f) => {

                if (f?.new_onorder) {
                    return colorSupp(f?.new_onorder, f?.priority, true)
                } else {
                    return colorSupp(e, f?.priority)
                }


            }
        },
        {
            key: "sell_price", width: 55, grow: true, title: <>SellPr</>, render: (e, f) => {
                return (e == minSalesPrice) ? <div className="text-olive">{drawPrice(e, true)}</div> : <>{drawPrice(e, true)}</>
            }
        },
        { key: "profit_margin", width: 21, grow: true, title: <>PM</> },
        {
            key: "profit_margin_2", width: 21, grow: true, title: <>P2</>, render: (e, f) => {

                if (e === "No stock") {
                    return (<></>)
                }

                return (<div className="text-olive">{getP2(f.cost)}</div>)
            }
        },
        {
            key: "supplier_price", width: 55, grow: true, title: <>SupPr</>, render: (e, f) => {

                if (f?.new_supplier_price) {
                    return <span className="text-green">{f?.new_supplier_price}</span>
                }

                return <span className={(f?.priority === "P") ? "label" : ""}>{drawPrice(e, true)}</span>
            }
        },
        {
            key: "discount", width: 25, grow: true, title: <>Disc</>, render: (e, f) => {

                if (f?.new_discount) {
                    return <span className="text-green">{f?.new_discount}</span>
                }
                return <span className={(f?.priority === "P") ? "label" : ""}>{e}</span>
            }
        },
        {
            key: "returnable", width: 15, grow: true, title: <>R</>, render: (e, f) => {
                return colorReturn(e);
            }
        },
        {
            key: "as_of", width: 55, grow: true, title: <a onClick={() => fetchLive([...pubstock])}>AsOf</a>, render: (e, f) => {

                if (f?.new_as_of) {
                    return (<span className="text-green">Now</span>)
                }

                return colorAsOf(e);
            }
        },


    ]

    if (can_toggle) {
        columns.push(
            {
                key: "pin", width: 16, grow: true, title: <>QP</>, render: (e, f) => {
                    return (<div><Checkbox onChange={() => togglePin(f)} value={pinned} /></div>)

                }
            }
        )
    }

    if (is_order) {


        if (filteredData?.length === 0 && !loading) {
            return (<div style={{ "width": "100%", "padding": "5px 0px" }}><Label style={{ "textAlign": "center" }}>No Pubstock for this title</Label></div>)
        }

        return (
            <>
                <Table
                    controller={controller}
                    grow
                    inline
                    className="pubstock_table"
                    height={"auto"}
                    offset={0}
                    columns={columns}
                    width={"auto"}
                    data={(loading) ? [] : filteredData}
                    row_key={"supplier"}
                />
            </>
        )
    }

    const height = (filteredData.length) ? filteredData.length * 25 + 25 : 50;


    const fetchLive = (_data) => {
        console.log("Called")
        setFetching(true)
        pubCall("title.getRemoteFeed", { primary_code: props.selected.primary_code }, (_s, _r) => {
            if (_s) {
                const result = _data.map(supplier => {
                    const updated = _r.find(item => item.supplier === supplier.supplier);
                    return {
                        ...supplier,
                        new_onhand: updated?.onhand ?? supplier.new_onhand,
                        new_onorder: updated?.onorder ?? supplier.new_onorder,
                        new_as_of: updated?.as_of ?? supplier.new_as_of,
                        new_discount: updated?.discount ?? supplier.new_discount,
                        new_supplier_price: updated?.supplier_price ?? supplier.new_discount,
                    };
                });
                setData(result)
            } else {
                showError(_r);
            }
            setFetching(false)
        })
    }


    return (
        <div style={{ "position": "relative", "width": "100%" }}>
            <div className="shadow" style={{ "position": "absolute", "bottom": "6px", "right": "5px", "fontSize": "14px", "zIndex": "1", "outline-offset": "2px", "outline": "2px solid var(--label)", "borderRadius": "5px" }}>
                <Spin loading={loading || fetching}>
                    <div style={{ "backgroundColor": "var(--text-black)", "borderTop": "0px solid var(--border-secondary)" }}>
                        <OtherConditions controller={controller} callback={(_stock) => {
                            if (controller === "reports") {
                                Cookies.set("inventory_stock_id", _stock.stock.stock_id);
                                window.ac = "inventory";
                                const event = new CustomEvent("switchController", { detail: "inventory" });
                                window.dispatchEvent(event);
                            } else {
                                alert("What to do here...")
                                //setConditionSelected(_stock)
                            }
                        }} data={(conditionSelected) ? conditionSelected?.other_conditions : other_conditions} />

                        {((pubstock?.length === 0 && !loading) &&
                            <div style={{ "textAlign": "center", "position": "relative", "top": "27px", "height": "0px", "zIndex": "10" }}>
                                <Label style={{ "textAlign": "center" }}>No Pubstock for this title</Label>
                            </div>
                        )}
                        <Table
                            controller={controller}
                            grow
                            inline
                            className="pubstock_table"
                            height={height}
                            offset={0}
                            columns={columns}
                            width={width}
                            data={(loading) ? [] : filteredData}
                            row_key={"supplier"}
                        />
                    </div>
                </Spin>
            </div>
        </div>
    );
}